import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const BreadcrumbSchema = ({ langUrl, pageUrl, PageTitle, defaultPageName }) => {
  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": defaultPageName,
      "item": langUrl
    },{
      "@type": "ListItem",
      "position": 2,
      "name": PageTitle,
      "item": pageUrl
    }]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

BreadcrumbSchema.propTypes = {
  langUrl: PropTypes.string.isRequired,
  PageTitle: PropTypes.string.isRequired,
  pageUrl: PropTypes.string.isRequired,
};

BreadcrumbSchema.defaultProps = {
  dateModified: '',
};

export default BreadcrumbSchema;
